// extracted by mini-css-extract-plugin
module.exports = {"avatarCenter":"Avatar_avatarCenter__1mh9v","avatarContainer":"Avatar_avatarContainer__dX18z","avatar":"Avatar_avatar__2ZY7Y"};